import { render } from "./MMDetailNews.vue?vue&type=template&id=1ab14e37"
import script from "./MMDetailNews.vue?vue&type=script&lang=js"
export * from "./MMDetailNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__